export const getErrorMessage = (response) => {
  let message = '';

  if (response.errors) {
    Object.keys(response.errors).forEach(v => {
      if (Array.isArray(response.errors[v])) {
        response.errors[v].forEach(m => {
          message += `${v}: ${m.message} `;
        });
      } else {
        message += response.errors[v].join(' ');
      }
    });
  } else if (response.message) {
    message = response.message;
  } else {
    message = response.statusText;
  }

  return message;
};
